import React from "react";
import { Page, Box, InlineStack, Text, ProgressBar } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";

function SetupTabs({ step, setStep }) {
  const navigate = useNavigate();

  const handleTabClick = (stepNumber) => {
    setStep(stepNumber);
    switch (stepNumber) {
      case 1:
        navigate("/tone-content");
        break;
      case 2:
        navigate("/content-setup");
        break;
      case 3:
        navigate("/article-suggestions");
        break;
      default:
        break;
    }
  };

  const customStyles = `
    .tabs-switch-container {
      display: flex;
      flex-direction: column;
      justify-content:flex-end;
      margin-bottom: 20px;
    }
    .tabs-switch-container div {
      display: flex;
      justify-content: space-around;
      width: 100%;
      margin-top:15px
    }
  `;
  return (
    <>
      <style>{customStyles}</style>
      <div style={{paddingLeft:'5px', paddingRight:'5px', marginBottom:'15px'}}>
        <div>
            <Box>
            <div className="tabs-switch-container">
                <InlineStack gap="400" direction="row" align="center">
                <Text
                    variant="headingMd"
                    color={step === 1 ? "base" : "subdued"}
                    onClick={() => handleTabClick(1)}
                >
                    Style and Tone
                </Text>
                <Text
                    variant="headingMd"
                    color={step === 2 ? "base" : "subdued"}
                    onClick={() => handleTabClick(2)}
                >
                    Topic Selection
                </Text>
                <Text
                    variant="headingMd"
                    color={step === 3 ? "base" : "subdued"}
                    onClick={() => handleTabClick(3)}
                >
                    Content Suggestions
                </Text>
                </InlineStack>

            </div>
                <ProgressBar
                progress={(step / 3) * 100}
                size="small"
                tone="primary"
                />
            </Box>
        </div>
      </div>
    </>
  );
}

export default SetupTabs;